export default "__VITE_ASSET__ba5d58d8__"